const woocommerce = document.querySelector(".woocommerce");

if (woocommerce) {
    let timer = null;

    let on_cart_change = form => {
        if (timer != undefined) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            form.querySelector('button[name="update_cart"]').click();
        }, 500);
    };

    let update_quantity = (form, input, value) => {
        let quantity = parseInt(input.value) + value;

        // Doesn't work if we don't use jQuery
        jQuery(input).val(Math.max(quantity, input.min));
        jQuery(input).change();

        on_cart_change(form);
    };

    let bind_cart = () => {
        const woocommerce_cart_form = document.querySelector(
            "form.woocommerce-cart-form"
        );

        if (!woocommerce_cart_form) {
            return;
        }

        const product_quantity = document.querySelectorAll(
            "td.product-quantity"
        );

        for (let index = 0; index < product_quantity.length; index++) {
            const item = product_quantity[index];

            const remove_icon = item.querySelector(".remove-icon");
            const add_icon = item.querySelector(".add-icon");
            const input = item.querySelector("input.qty");

            remove_icon.addEventListener("click", event => {
                event.preventDefault();
                update_quantity(woocommerce_cart_form, input, -1);
            });

            add_icon.addEventListener("click", event => {
                event.preventDefault();
                update_quantity(woocommerce_cart_form, input, 1);
            });
        }

        const input_quantity = document.querySelectorAll("input.qty");

        for (let index = 0; index < input_quantity.length; index++) {
            const input = input_quantity[index];

            input.addEventListener("change", event => {
                on_cart_change(woocommerce_cart_form);
            });
        }
    };

    // rebind events afer woocommerce update
    woocommerce.addEventListener("DOMNodeInserted", function(event) {
        if (
            event.target.classList != undefined &&
            event.target.classList.contains("woocommerce-cart-form")
        ) {
            bind_cart();
        }
    });
    bind_cart();
}
